import { render } from "./TenantPage.vue?vue&type=template&id=ea495350"
import script from "./TenantPage.vue?vue&type=script&lang=js"
export * from "./TenantPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Development/lotte-deploy/cms-prod-lodash-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__